import { ErrorLogComponent } from '@cian/error-log-component';
import { Provider as MicrofrontendProvider } from '@cian/mf-react';
import { UiKitRoot } from '@cian/ui-kit/root/UiKitRoot';

import * as React from 'react';
import { Provider as StoreProvider } from 'react-redux';

import { DistrictsPopupContainerLoadable } from '@/microfrontends/filters/shared/containers/DistrictsPopup';
import { FiltersContainer } from '@/microfrontends/filters/shared/containers/Filters';
import { LocationPopupContainerLoadable } from '@/microfrontends/filters/shared/containers/LocationPopup';
import { RegionalDistrictsPopupContainerLoadable } from '@/microfrontends/filters/shared/containers/RegionalDistrictsPopup';
import { SaveSearchModalProvider } from '@/microfrontends/filters/shared/containers/SaveSearchModalProvider';
import { SubscriptionsContainer } from '@/microfrontends/filters/shared/containers/Subscriptions';
import { type TReduxStore } from '@/microfrontends/filters/shared/store';
import { ApplicationContext } from '@/microfrontends/filters/shared/utils/applicationContext';

import { type IApplicationContext } from '../../types/applicationContext';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: React.FC<IApplicationProps> = ({ reduxStore, context }) => {
  const { logger, microfrontendsRegistry } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitRoot deviceType="desktop">
          <StoreProvider store={reduxStore}>
            <MicrofrontendProvider registry={microfrontendsRegistry}>
              <SaveSearchModalProvider>
                <SubscriptionsContainer reduxStore={reduxStore} />
                <FiltersContainer />
                <LocationPopupContainerLoadable />
                <DistrictsPopupContainerLoadable />
                <RegionalDistrictsPopupContainerLoadable />
              </SaveSearchModalProvider>
            </MicrofrontendProvider>
          </StoreProvider>
        </UiKitRoot>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
